import { render, staticRenderFns } from "./EditFieldOrderServices.vue?vue&type=template&id=01c747ac"
import script from "./EditFieldOrderServices.vue?vue&type=script&lang=js"
export * from "./EditFieldOrderServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports